<div
  class="home w-full h-full bg-cover bg-center relative overflow-hidden flex flex-col"
  [style.background-color]="kioskConfig().primaryColor"
  [style.background-image]="kioskConfig().homeBackgroundUrl ? 'url(' + kioskConfig().homeBackgroundUrl + ')' : 'none'">
  @if (kioskConfig().usesDefaultHomeDesign) {
  <img src="/home/bg-icon-1.png" alt="bg-icon-1" class="absolute -bottom-13 -left-21 z-10" />
  <img src="/home/bg-icon-2.png" alt="bg-icon-2" class="absolute -bottom-5 -right-20 z-10" />
  <img src="/home/bg-icon-3.svg" alt="bg-icon-3" class="absolute -bottom-7 left-64 z-12" />
  }

  <!-- 헤더 -->
  <header class="fixed px-10 py-6 z-20 w-full flex items-center justify-between">
    @if (!isHomePage()) {
    <a routerLink="/" class="cursor-pointer">
      @if (kioskConfig().logoUrl) {
      <img [src]="kioskConfig().logoUrl" alt="logo" class="w-20" />
      }
    </a>
    }
    <button (click)="goToSettings()" class="cursor-pointer flex items-center gap-2 p-2 text-white opacity-5 ml-auto">
      <app-icon name="material-symbols:settings" class="size-10!" />
    </button>
  </header>

  <!-- 메인 컨텐츠 영역 -->
  <main class="flex-1 relative z-10 overflow-y-auto overflow-x-hidden scrollbar-hide">
    <router-outlet></router-outlet>
  </main>

  @if (!isHomePage()) {
  <div class="fixed bottom-0 left-0 right-0 z-30 bg-white p-8">
    @if (isCompletePage() || isEventListPage()) {
    <button routerLink="/" class="cursor-pointer w-full flex items-center justify-center gap-2">
      <app-icon name="material-symbols:home" class="size-10! text-zinc-700" />
      <span class="text-zinc-700 text-3xl font-bold">홈으로</span>
    </button>
    } @else {
    <button (click)="goBack()" class="cursor-pointer w-full flex items-center justify-center gap-2">
      <app-icon name="material-symbols:arrow-left-alt-rounded" class="size-10! text-zinc-700" />
      <span class="text-zinc-700 text-3xl font-bold">뒤로가기</span>
    </button>
    }
  </div>
  }
</div>
